const initData = ''
//Redux datan hallinnalle
const dataReducer = (state = initData, action) => {
  switch (action.type) {
  case 'SETDATA':
    return action.data
  default:
    return state
  }
}

export const dataArray = (data) => {
  return {
    type: 'SETDATA',
    data
  }
}

export const setData = (data) => {
  return async (dispatch) => {
    dispatch(dataArray(data))
  }
}

export default dataReducer